import { FormikProvider, useFormik } from 'formik'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { Container, Form, TabContent, TabPane } from 'reactstrap'
import * as Yup from 'yup'
import contacts from '../../api/contacts/hooks'
import { ContactType } from '../../api/globalTypes'
import FormActionButtons from '../../Components/Common/FormActionButtons'
import PageTitle from '../../Components/Common/PageTitle'
import ContactFormGeneralTab, {
    ContactFormGeneralTabMain,
    ContactFormGeneralTabSide,
} from '../../Components/ContactFormGeneralTab/ContactFormGeneralTab'
import { useFormValidationErrorModal } from '../../Components/Modals/FormValidationErrorModal/useFormValidationErrorModal'
import { contactFormTabs } from '../Contacts/constants'
import { useContactGeneralFormConfig } from '../Contacts/hooks'

const CompanyCreate = () => {
    const history = useHistory()
    const { t } = useTranslation()

    const tabs = contactFormTabs(false)
    const [activeTab, setActiveTab] = useState(tabs[0]?.name)

    const { generalInputs, generalValidationConfig } = useContactGeneralFormConfig(null, ContactType.Company)

    const { mutate: createCompany, isPending } = contacts.CreateUpdateContact.useMutation()

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            general: generalValidationConfig.initialValues ?? {},
        },
        validationSchema: Yup.object({
            general: generalValidationConfig.validationSchema ?? Yup.object({}),
        }),
        onSubmit: (values) => {
            const submitValues = {
                ...generalValidationConfig.prepareModelForSubmit(values.general),
                contact_type: ContactType.Company,
            }

            delete submitValues.id

            createCompany({ data: submitValues, isEdit: false, contactType: ContactType.Company })
        },
    })

    useFormValidationErrorModal(formik, [generalInputs])

    const handleTabChange = (tab: string) => {
        if (activeTab !== tab) {
            setActiveTab(tab)
        }
    }

    const renderFormButtons = () => <FormActionButtons disabled={isPending} hasCancel={true} cancelAction={() => history.push('/companies')} />

    return (
        <div className="page-content">
            <Container fluid>
                <FormikProvider value={formik}>
                    <Form onSubmit={(e) => formik.handleSubmit(e)}>
                        <PageTitle title={t('page.newCompany')}>{renderFormButtons()}</PageTitle>

                        <TabContent activeTab={activeTab} className="text-muted">
                            <TabPane tabId="general">
                                <ContactFormGeneralTab
                                    subform="general"
                                    tabs={tabs}
                                    activeTab={activeTab}
                                    inputs={generalInputs}
                                    formik={formik}
                                    contactType={ContactType.Company}
                                    handleTabChange={handleTabChange}
                                >
                                    <ContactFormGeneralTabSide />
                                    <ContactFormGeneralTabMain />
                                </ContactFormGeneralTab>
                            </TabPane>
                        </TabContent>
                    </Form>
                </FormikProvider>
            </Container>
        </div>
    )
}

export default CompanyCreate
